import React from 'react';

interface AppStoreBadgesProps {
  scale?: number;
  dark?: boolean;
}

export function AppStoreBadges({ scale = 1, dark = true }: AppStoreBadgesProps) {
  const bg = dark ? '#FFFFFF' : '#12161F';
  const fg = dark ? '#12161F' : '#FFFFFF';

  const badgeStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8 * scale,
    background: bg,
    color: fg,
    padding: `${8 * scale}px ${14 * scale}px`,
    borderRadius: 8 * scale,
    fontFamily: '"Inter",system-ui',
    lineHeight: 1,
  };

  return (
    <div style={{ display: 'flex', gap: 10 * scale, flexWrap: 'wrap' }}>
      {/* App Store Badge */}
      <div style={badgeStyle}>
        <svg width={20 * scale} height={20 * scale} viewBox="0 0 24 24" fill={fg}>
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
        </svg>
        <div>
          <div style={{ fontSize: 8 * scale, opacity: 0.7 }}>Download on the</div>
          <div style={{ fontSize: 13 * scale, fontWeight: 600, marginTop: 1 }}>App Store</div>
        </div>
      </div>

      {/* Google Play Badge */}
      <div style={badgeStyle}>
        <svg width={20 * scale} height={20 * scale} viewBox="0 0 24 24">
          <defs>
            <linearGradient id="ga" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0" stopColor="#34d399" />
              <stop offset="1" stopColor="#2563eb" />
            </linearGradient>
          </defs>
          <path
            d="M3.6 2.3c-.4.4-.6 1-.6 1.7v16c0 .7.2 1.3.6 1.7L12 13 3.6 2.3z"
            fill="url(#ga)"
          />
          <path
            d="M16.5 9.5l-2.8 1.6L12 13l1.7 1.9 2.8 1.6 3.3-1.9c1-.6 1-2.1 0-2.6l-3.3-2.5z"
            fill="#fbbf24"
          />
          <path d="M3.6 2.3L12 13l1.7-1.9L4.6 2C4.3 2 3.9 2.1 3.6 2.3z" fill="#ef4444" />
          <path d="M12 13l-8.4 10.7c.3.2.7.3 1 .3L13.7 14.9 12 13z" fill="#10b981" />
        </svg>
        <div>
          <div style={{ fontSize: 8 * scale, opacity: 0.7 }}>Get it on</div>
          <div style={{ fontSize: 13 * scale, fontWeight: 600, marginTop: 1 }}>Google Play</div>
        </div>
      </div>
    </div>
  );
}
